import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import React, { useState, useEffect } from "react";
import { PaginationProps } from "antd/es/pagination";
import { IStaffSearch, IStaffDetail, IStaffFields } from "./staffType"
import { staffService } from "./staffService";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { message } from "antd";
import { globalPrompt } from "@/components/message";
import { transPgToPagination } from "@/utils/utils";
import { useGlobalModel, getFindItem } from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export const useStaffModel = createModel(function () {
    const { user, warehouseList,setLocale } = useGlobalModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const Locale = setLocale(LanguageArr)

    const initSearchParam: IStaffSearch = {};
    const initDataSource: IStaffDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IStaffSearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IStaffDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //列表数据源分页参数
    const [selectedRow, setSelectedRow] = useState<IStaffFields>({});

    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [detailDrawer, setDetailDrawer] = useState<boolean>(false)
    const [detailType, setDetailType] = useState<string>("");
    //编辑表单缓存
    const [editFormVal, setEditFormVal] = useState<IStaffDetail>({});
    //新增表单缓存
    const [addFormVal, setAddFormVal] = useState<IStaffDetail>({});

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        const newSelectedData = {
            ...selectedData,
            roleIdLists: selectedData?.roleIdList?.map(item => (item.roleId)) ?? []
        }
        setSelectedRow(newSelectedData as IStaffFields)
    }, [selectedRowKeys])

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IStaffSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
    }
    const loadData = async (page?: ISearchPage, searchValue: IStaffSearch = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await staffService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        setSelectedRowKeys([])
    }

    //表单新增 
    const insertDetail = async (data: IStaffDetail) => {
        let { retData } = await staffService.insert(data)
        retData ?
            // loadData() && globalPrompt("message", { text: "员工新增成功", type: "success" })
            // : globalPrompt("message", { text: "员工新增失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully edited"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully edited"], type: "error" });            
        return retData;
    }
    //表单编辑
    const editDetail = async (data: IStaffDetail) => {
        let { retData } = await staffService.update(data)
        retData ?
            // loadData() && globalPrompt("message", { text: "员工编辑成功", type: "success" })
            // : globalPrompt("message", { text: "员工编辑失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully edited"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully edited"], type: "error" });
        return retData;
    }
    const onChange = async (id: string, checked: boolean) => {
        let { retData } = await staffService.change({ id, status: checked ? 1 : 0 })
        retData ?
            // loadData() && globalPrompt("message", { text: "状态修改成功", type: "success" })
            // : globalPrompt("message", { text: "状态修改失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully edited"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully edited"], type: "error" });
        return retData;
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedRow,
        detailDrawer,
        detailType,
        editFormVal,
        addFormVal,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setSelectedRow,
        onChange,
        setDetailDrawer,
        setDetailType,
        setEditFormVal,
        setAddFormVal,
        insertDetail,
        editDetail
    }
});